import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SupabaseClientService } from './db/supabase-client';
import { User } from "@supabase/supabase-js";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private userSubject = new BehaviorSubject<User | null>(null);
  public user$ = this.userSubject.asObservable();

  constructor(private supabase: SupabaseClientService) {
    // Listen to auth state changes
    this.supabase.authState$.subscribe(session => {
      this.userSubject.next(session?.user ?? null);
    });
  }
  
  get user(): User | null {
    return this.userSubject.value;
  }

  /**
   * Sign up with email and password
   */
  signUp(email: string, password: string) {
    return this.supabase.signUp(email, password);
  }

  /**
   * Sign in with email and password
   */
  signIn(email: string, password: string) {
    return this.supabase.signIn(email, password);
  }

  /**
   * Sign out
   */
  signOut() {
    return this.supabase.signOut();
  }
}
